<template>
    <div v-if="getInviteInfo">
        <invite-code-header page-name="招待コード"></invite-code-header>
        <invite-code-qr></invite-code-qr>
        <invite-code-share></invite-code-share>
    </div>
</template>

<script>
    import InviteCodeHeader from 'pages/commons/header/Header'
    import InviteCodeQr from './components/Code'
    import InviteCodeShare from './components/Share'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            InviteCodeHeader,
            InviteCodeQr,
            InviteCodeShare
        },
        watch: {
            getInviteInfoLoadStatus () {
                if (this.getInviteInfoLoadStatus == 1) {
                    this.$store.dispatch('startProgress')
                }

                if (this.getInviteInfoLoadStatus == 2) {
                    this.$store.dispatch('doneProgress')
                }

                if (this.getInviteInfoLoadStatus == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        created () {
            this.loadInviteInfo()
        },
        computed: {
            ...mapGetters(['getInviteInfo', 'getInviteInfoLoadStatus'])
        },
        methods: {
            loadInviteInfo () {
                this.$store.dispatch('loadInviteInfo')
            }
        }
    }

</script>

<style lang="stylus" scoped>

</style>
